import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { Spinner } from "@shared-kernel/primary/shared/ui/spinner";
import type { LoadingStateProps } from "../types";

export const LoadingState = ({ className }: LoadingStateProps) => {
  return (
    <div className={cn("flex items-center justify-center py-12", className)}>
      <div className="flex flex-col items-center gap-3">
        <Spinner size="lg" />
        <span className="text-sm text-muted-foreground">Chargement...</span>
      </div>
    </div>
  );
};
